import { Users, Gift, FileBarChart, Settings } from "lucide-react"
import type { LucideIcon } from "lucide-react"

// ----------------------------------------------------------------------------

export interface NavItem {
  title: string
  url: string
  icon: LucideIcon
  requiredRole?: "admin" | "operator" | "viewer"
}

export const navigationItems: NavItem[] = [
  { title: "Utenti App", url: "/customers", icon: Users },
  { title: "Catalogo Premi", url: "/rewards", icon: Gift, requiredRole: "admin" },
  { title: "Report", url: "/reports", icon: FileBarChart },
  { title: "Impostazioni", url: "/settings", icon: Settings, requiredRole: "admin" },
]
